import { Layers } from 'lucide-react';
import { cn } from '@/utils/cn';

/**
 * Wordmark. An icon plus type, never an emoji.
 *
 * `size="sm"` is for the dense app-shell chrome (sidebar, mobile drawer,
 * topbar's mobile-only mark); the public marketing header keeps the default.
 */
export function Logo({
  collapsed,
  size = 'default',
  className,
}: {
  collapsed?: boolean;
  size?: 'default' | 'sm';
  className?: string;
}) {
  const sm = size === 'sm';
  return (
    <span className={cn('flex items-center', sm ? 'gap-1.5' : 'gap-2.5', className)}>
      <span
        className={cn(
          'flex shrink-0 items-center justify-center rounded-md bg-accent text-accent-fg',
          sm ? 'h-5 w-5' : 'h-7 w-7',
        )}
      >
        <Layers className={sm ? 'h-3 w-3' : 'h-4 w-4'} aria-hidden="true" />
      </span>
      {!collapsed ? (
        <span className={cn('font-semibold tracking-tight text-fg', sm ? 'text-xs' : 'text-sm')}>
          Design MD
        </span>
      ) : null}
    </span>
  );
}
